import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-layout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_StatsSidebar = _resolveComponent("StatsSidebar")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_FeedbackButton = _resolveComponent("FeedbackButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navigation),
    (_ctx.showStatsSidebar)
      ? (_openBlock(), _createBlock(_component_StatsSidebar, {
          key: 0,
          ref: "statsSidebarRef"
        }, null, 512))
      : _createCommentVNode("", true),
    _createElementVNode("main", {
      class: _normalizeClass(["main-content", { 'no-sidebar': !_ctx.showStatsSidebar }])
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 2),
    _createVNode(_component_Footer),
    _createVNode(_component_FeedbackButton)
  ]))
}